import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container} from 'react-bootstrap'
import FiltrosInforme from './filtros-informe'
//import FiltrosInforme from './informes'
import InformePrevios from './informes-previos'
import {Auth, LoadingComponent} from 'recupero-comunes'
import { obtenerInformesPrevios, configuracionFormAction, obtenerTiposInforme, obtenerResponsables} from '../../store/actions/informes-profesionales-action'

const InformesProfesionales = () => {
    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)
    const data_informes = useSelector((state) => state.informesProfesionalesReducer)
    const { cfg_formInf } = data_informes
    const {rutUsuario, rutOrganizacion} = Auth.currentUser()
    
    useEffect(() => {
        setLoading(true)
        let query = Buffer.from(JSON.stringify({rutcia: rutOrganizacion, idform: 96})).toString('base64')
        dispatch(configuracionFormAction(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 299})).toString('base64')
            dispatch(obtenerTiposInforme(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
            dispatch(obtenerInformesPrevios(query));
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion})).toString('base64')  
            dispatch(obtenerResponsables(query));
         })
        .then(()=>setLoading(false))
     }, [dispatch])
    return (
        <div>            
            <LoadingComponent show={loading}/>
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                        {cfg_formInf && `${cfg_formInf.cfg_formInf['informes-prof-title']}`}
                    </Card.Header>
                    <Card.Body>
                        <FiltrosInforme/>
                        <InformePrevios/>
                    </Card.Body>
                </Card>
            </Container>            
        </div>
  )
}
export default InformesProfesionales 